import React, { memo } from 'react';
import { useButtonPad } from '../hooks/useButtonPad';
import { ButtonSkeleton, ButtonGrid } from './ButtonPadComponents';

/**
 * ButtonPad - Pure presentation component
 * Button Grid is a memoized component that renders a grid of buttons
 * See ButtonPadComponents.jsx for the ButtonGrid and ButtonSkeleton components.
 *
 * Uses a single hook that combines data fetching, business logic, and state management.
 * The real "models" are the underlying hooks (useClockConnect, useMissingPunches, etc.)
 */
const ButtonPad = memo(() => {
  const {
    buttonState,
    isLoading,
    buttonPadLoading,
    buttonLoading,

    handleButtonClick,
  } = useButtonPad();

  if (isLoading) {
    return <ButtonSkeleton count={buttonState.skeletonCount} />;
  }

  return (
    <ButtonGrid
      buttonList={buttonState.buttonList}
      disabledButtons={buttonState.disabledButtons}
      missingPunches={buttonState.missingPunches}
      buttonPadLoading={buttonPadLoading}
      buttonLoading={buttonLoading}
      onButtonClick={handleButtonClick}
    />
  );
});

ButtonPad.displayName = 'ButtonPad';

export default ButtonPad;
